var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83344 4.332C9.938 4.332 10.8334 3.43657 10.8334 2.332C10.8334 1.22743 9.938 0.332001 8.83344 0.332001C7.72887 0.332001 6.83344 1.22743 6.83344 2.332C6.83344 3.43657 7.72887 4.332 8.83344 4.332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 7.332C14.7887 7.332 15.8334 6.28733 15.8334 4.99866C15.8334 3.71 14.7887 2.66533 13.5001 2.66533C12.2114 2.66533 11.1667 3.71 11.1667 4.99866C11.1667 6.28733 12.2114 7.332 13.5001 7.332Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16675 3.66534C6.16675 4.76991 5.27132 5.66534 4.16675 5.66534C3.06218 5.66534 2.16675 4.76991 2.16675 3.66534C2.16675 2.56077 3.06218 1.66534 4.16675 1.66534C5.27132 1.66534 6.16675 2.56077 6.16675 3.66534Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83341 9.332C2.75389 9.332 3.50008 8.58581 3.50008 7.66533C3.50008 6.74486 2.75389 5.99866 1.83341 5.99866C0.91294 5.99866 0.166748 6.74486 0.166748 7.66533C0.166748 8.58581 0.91294 9.332 1.83341 9.332Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50008 11.6653C4.50008 12.5858 3.75389 13.332 2.83341 13.332C1.91294 13.332 1.16675 12.5858 1.16675 11.6653C1.16675 10.7449 1.91294 9.99866 2.83341 9.99866C3.75389 9.99866 4.50008 10.7449 4.50008 11.6653Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16677 15.6653C6.90315 15.6653 7.5001 15.0684 7.5001 14.332C7.5001 13.5956 6.90315 12.9987 6.16677 12.9987C5.43039 12.9987 4.83344 13.5956 4.83344 14.332C4.83344 15.0684 5.43039 15.6653 6.16677 15.6653Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7501 14.4293C10.7501 14.9816 10.3024 15.4293 9.75009 15.4293C9.19781 15.4293 8.75009 14.9816 8.75009 14.4293C8.75009 13.8771 9.19781 13.4293 9.75009 13.4293C10.3024 13.4293 10.7501 13.8771 10.7501 14.4293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.a30193acbb5e0437eb6b1b1c8cd42ac1.svg";
export { ForwardRef as ReactComponent };